import React from 'react';
import { ElementypesToIcons, Icons } from './Icons';
import { globals } from '../../../lib/EnvironmentDetection';
import { ElementType } from '../../../types/api/ElementType';

const getIcon = (svgSpriteId: typeof Icons | ElementType) =>
  ElementypesToIcons.get(svgSpriteId as ElementType) || svgSpriteId;

export type SVGIcon = typeof Icons | ElementType;

type SVGProps = {
  svgSpriteId: SVGIcon;
  inverted?: boolean;
  svgClass?: string;
  focusable?: boolean;
};

export function SVG({ svgClass = '', svgSpriteId, inverted = false, focusable = false }: SVGProps) {
  const baseClass = inverted ? 'svg svg--inverted' : 'svg';

  return (
    <svg
      className={`${baseClass}${svgClass ? ` ${svgClass}` : ''}`}
      aria-hidden="true"
      focusable={focusable}
      // this has to be an integer and it represents pixel
      width="16"
      height="16"
    >
      <use href={`/assets/images/icons/sprite.${globals.bundleHash}.svg#${getIcon(svgSpriteId)}`} />
    </svg>
  );
}
